module.exports = __webpack_public_path__ + "static/media/onBoarding.967d403e.webp";